import { Role, useRolesManager } from "@/stores/roles-store";
import { watch } from "vue";
import { until } from "@vueuse/core";
import { BaseLinkedEntitiesManager } from "../mystekz-linked-entities/manager";
import { RoleEntity } from ".";

export class RolesManager extends BaseLinkedEntitiesManager<RoleEntity> {
    nodeType = "role" as const;

    constructor(baseUrl: string) {
        const { roles, isLoading } = useRolesManager();

        super(baseUrl);
        this.events = new EventTarget();
        this.ready = until(isLoading).not.toBeTruthy();

        watch(
            roles,
            async (newValue) => {
                if (newValue) {
                    this.setEntities(newValue);
                }
            },
            { immediate: true }
        );
    }

    itemToEntity(role: Role): RoleEntity {
        return {
            name: role.name,
            id: role.identity,
            orgName: this.organizationManager.organization?.value?.name,
            stekName: this.stekManager.stek?.value?.name,
            type: this.nodeType,
            data: role,
            state: "ready",
            href: "",
        } as RoleEntity;
    }
}
